import type { TmTransportHttpErrorCode } from '@/core/error/transport/types'
import type { InternalErrorResponse, TmAxiosResponse } from '@/services/transport/types'
import { TmApiError } from '@/core/error/transport/tmApiError'

export class TmApiUnprocessableContentError<T extends InternalErrorResponse = InternalErrorResponse> extends TmApiError<
  TmAxiosResponse<T>
> {
  public name = 'TmApiUnprocessableContentError'

  protected override code: TmTransportHttpErrorCode = 422

  protected commonErrors: string[] | null = null

  constructor(msg?: string, data?: TmAxiosResponse<T>, stack?: string) {
    super(msg, data, stack)
    if (data?.data.errors?.common) {
      this.commonErrors = data.data.errors.common
    }
  }

  public getCommonErrors() {
    return this.commonErrors
  }

  public getFirstCommonError(): string | null {
    if (this.commonErrors?.length) {
      return this.commonErrors[0]
    }
    return null
  }
}
